// PaymentPlanDetailsStore
import {defineStore} from 'pinia'
import {ref} from 'vue';
import * as _ from 'lodash';   
import {IClaim,IClaimList,ClaimSelectionType} from '../../lib/Models/ClaimModel'; 


interface INewPaymentPlanClaims {
    claimId: number,
    charges: number,
    payments: number,
    adjustments: number,
    balance: number,
    isSelected: boolean
};
export const usePaymentPlanDetailsStore = defineStore('PaymentPlanDetailsStore', () => {
    const patientBalanceClaims = ref<INewPaymentPlanClaims[]>([]);
    const includedBalanceClaims = ref<INewPaymentPlanClaims[]>([]);
    const paidClaims = ref<IClaim[]>([]);

    function resetPaidClaims() : void {
        paidClaims.value = [];
    } 
    function resetPatientClaims() : void {
        patientBalanceClaims.value = [];
    } 
    function resetIncludedClaims() : void {
        includedBalanceClaims.value = [];
    }  
    function loadPaidClaims(claims: IClaim[]) : void { 
        paidClaims.value = claims;
    }
    function updateClaim(area: ClaimSelectionType, claimId : number, charges : number, payments: number, adjustments: number, balance : number) : void {
        const claim_data : INewPaymentPlanClaims = {claimId: claimId, charges: charges, payments: payments, adjustments: adjustments, balance: balance, isSelected: false};
        const search_index = 
            (area == ClaimSelectionType.Patient ? 
                patientBalanceClaims.value.findIndex(item => item.claimId == claimId) : 
                includedBalanceClaims.value.findIndex(item => item.claimId == claimId)
            );
        if ((search_index == -1) && (area == ClaimSelectionType.Patient)) {
            patientBalanceClaims.value.push(claim_data);
        } 
        else if ((search_index == -1) && (area == ClaimSelectionType.Included)) {
            includedBalanceClaims.value.push(claim_data);
        }
        else if (area == ClaimSelectionType.Patient) {
            patientBalanceClaims.value[search_index] = claim_data;
        } 
        else if (area == ClaimSelectionType.Included) {
            includedBalanceClaims.value[search_index] = claim_data;
        }
    }
    function selectPatientClaim(claimListing : IClaimList) : void {        
        const search_index = patientBalanceClaims.value.findIndex(item => item.claimId == claimListing.claimID);
        if (search_index != -1) {
            patientBalanceClaims.value[search_index].isSelected = claimListing.selected;
        }
    }
    function selectIncludedClaim(claimListing : IClaimList) : void {        
        const search_index = includedBalanceClaims.value.findIndex(item => item.claimId == claimListing.claimID);
        if (search_index != -1) {
            includedBalanceClaims.value[search_index].isSelected = claimListing.selected;
        }
    }
    function getTotalBalance(area: ClaimSelectionType) : number {
        const total_balance = 
            (area === ClaimSelectionType.Patient ?
                patientBalanceClaims.value.map(item => item.balance).flat().reduce((accumulator, currentValue) => accumulator + currentValue, 0) :
                includedBalanceClaims.value.map(item => item.balance).flat().reduce((accumulator, currentValue) => accumulator + currentValue, 0)
            );
        
        return total_balance ?? 0;
    }
    function getTotalBalanceSelected(area: ClaimSelectionType) : number {
        const total_selected_balance = 
            (area === ClaimSelectionType.Patient ?
                patientBalanceClaims.value.filter(item => item.isSelected).map(item => item.balance).flat().reduce((accumulator, currentValue) => accumulator + currentValue, 0) :
                includedBalanceClaims.value.filter(item => item.isSelected).map(item => item.balance).flat().reduce((accumulator, currentValue) => accumulator + currentValue, 0)
            );
        
        return total_selected_balance ?? 0;
    }

    return {includedBalanceClaims,resetIncludedClaims,selectIncludedClaim,
            patientBalanceClaims,resetPatientClaims,selectPatientClaim,
            paidClaims,resetPaidClaims,loadPaidClaims,
            updateClaim,getTotalBalance,getTotalBalanceSelected};
});


